import { z } from 'zod';
import { catalogItemListItem } from './catalog';

/**
 * Schemas for the per-user Library (favorite/saved catalog items).
 *
 * Path: `/library`
 *
 * LibraryItem is a join table linking User → CatalogItem for personal favorites.
 * Users can add/remove catalog items to/from their library for quick access.
 */

export const libraryItem = z.object({
  id: z.string().cuid(),
  userId: z.string().cuid(),
  catalogItemId: z.string().cuid(),
  createdAt: z.string().datetime(),
  // Optional embedded catalog item for list responses
  catalogItem: catalogItemListItem.optional(),
});
export type LibraryItem = z.infer<typeof libraryItem>;

export const addLibraryItemRequest = z.object({
  catalogItemId: z.string().cuid(),
});
export type AddLibraryItemRequest = z.infer<typeof addLibraryItemRequest>;

export const listLibraryResponse = z.array(libraryItem);
export type ListLibraryResponse = z.infer<typeof listLibraryResponse>;
